import React, { useEffect } from 'react';
import { TravelBotChatSingleDialogGeneric } from './TravelBotChatSingleDialogGeneric';
let count = 0;
export const BlockingInputComponent = React.memo(props => {
  const {
    setIsDisablingInputValue
  } = props;
  const shouldBlockInput = count === 5;
  useEffect(() => {
    if (shouldBlockInput) {
      setIsDisablingInputValue(true);
      setTimeout(() => {
        setIsDisablingInputValue(false);
      }, 30 * 1000);
    } else {
      count++;
    }
  }, []);
  return shouldBlockInput ? React.createElement(TravelBotChatSingleDialogGeneric, {
    message: {
      role: 'assistant',
      content: 'Sorry, service will be disabled for 30s.'
    }
  }) : null;
});